// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&family=Merriweather:wght@400;400&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* --- Global Styles --- */

body {
  font-family: 'Roboto', serif;
  background-color: #f9f9f9;
  margin: 0;
  padding: 0;
}

/* --- RSS Feed Container --- */
.rss-feed {
  background-color: #fff;
  max-width: 800px;
  margin-bottom: 40px;
  margin-top: 5px;
  margin-left: auto;
  margin-right: auto;
  padding: 20px 16px; /* 🔁 previously padding: 20px */
  border-radius: 10px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
}


.rss-feed-title {
  font-size: 24px;
  color: #2C3E50;
  margin: 0 auto 20px;
  text-align: center;
  white-space: nowrap;
}

/* --- Category Dropdown --- */
.category-dropdown {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 20px;
  background: #f8f8f8;
  border-bottom: 1px solid #eee;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;     /* ✅ center it horizontally */
}

.category-dropdown label {
  font-weight: 500;
  font-size: 16px;
  color: #333;
  margin: 0 !important;
  line-height: 1;
  white-space: nowrap;
}

.category-dropdown select {
  height: 36px;
  padding: 4px 12px;
  border: 1px solid #ccc;
  border-radius: 6px;
  font-size: 15px;
  background-color: white;
  line-height: 1.2;
  appearance: none;
}

.loader {
  margin: 50px auto;
  width: 60px;
  height: 40px;
  color: #000;
  border: 2px solid currentColor;
  border-right-color: transparent;
  padding: 3px;
  background: repeating-linear-gradient(
    90deg,
    currentColor 0 10px,
    #0000 0 15px
  ) 0/0% no-repeat content-box content-box;
  position: relative;
  box-sizing: border-box;
  animation: l5 2s infinite steps(6);
  display: block;
}

.loader::before {
  content: "";
  position: absolute;
  top: -2px;
  bottom: -2px;
  left: 100%;
  width: 10px;
  background:
    linear-gradient(#0000 calc(50% - 7px), currentColor 0 calc(50% - 5px),
    #0000 0 calc(50% + 5px), currentColor 0 calc(50% + 7px), #0000 0) left/100% 100%,
    linear-gradient(currentColor calc(50% - 5px), #0000 0 calc(50% + 5px), currentColor 0) left/2px 100%,
    linear-gradient(#0000 calc(50% - 5px), currentColor 0 calc(50% + 5px), #0000 0) right/2px 100%;
  background-repeat: no-repeat;
}

@keyframes l5 {
  100% {
    background-size: 120%;
  }
}

/* --- RSS Items --- */
.rss-feed-list {
  list-style: none;
  padding: 0;
  padding: 20px 12px;
}

.rss-feed-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 10px;
  background-color: #f9f9f9;
  border-radius: 5px;
}

.rss-feed-item-image {
  flex: 0 0 120px;
  height: 120px;
  margin-right: 20px;
  cursor: pointer;
}

.enclosure-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 5px;
}

.rss-feed-item-content {
  flex: 1 1;
}

.rss-feed-item-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 10px;
  font-family: 'Merriweather', sans-serif;
  cursor: pointer;
}

.rss-feed-item-title:hover {
  color: rgb(82, 109, 244);
}

.rss-feed-item-description {
  font-size: 16px;
  color: #666;
  margin-bottom: 10px;
}

.rss-feed-item-date {
  font-size: 14px;
  color: #999;
  margin-bottom: 10px;
}

/* --- Subscribe Styles --- */
.subscribe-container {
  display: flex;
  justify-content: flex-end;
  margin: 0;
  padding: 0;
  width: auto;
}

.subscribe-button {
  background-color: #35495E;
  color: white;
  border: none;
  border-radius: 8px;
  height: 40px;
  padding: 0 20px;
  font-size: 15px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  transition: background-color 0.3s ease;
  line-height: 1;
}

.subscribe-button:hover {
  background-color: #2c3e50;
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
}

.subscribe-text {
  position: relative;
  top: 1px;
}

.mobile-button {
  width: 40px !important;
  height: 40px !important;
  padding: 0 !important;
  display: flex !important;
  align-items: center !important;
  justify-content: center !important;
  margin: 0 !important;
  border-radius: 6px;
  box-shadow: none !important;
  vertical-align: middle;
}

/* --- Blog Header --- */
.blog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 10px 24px;
  width: 100%;
  box-sizing: border-box;
  border-bottom: 1px solid #eee;
  height: auto;
}

.nav-home-container,
.subscribe-container-wrapper {
  flex-shrink: 0;
  width: 48px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  padding: 0;
}

.subscribe-container-wrapper {
  height: 40px;
  width: auto;
}

/* --- Responsive Styles --- */
@media (max-width: 600px) {
  .rss-feed {
    padding: 20px 12px;
  }

  .rss-feed-title {
    font-size: 20px;
  }

  .rss-feed-item {
    flex-direction: column;
    align-items: center;
  }

  .rss-feed-item-image {
    width: 100%;
    height: auto;
    margin-bottom: 10px;
  }

  .category-dropdown {
    justify-content: center;
    gap: 10px;
    padding: 10px 15px;
  }

  .category-dropdown label {
    margin: 0 !important;
  }

  .subscribe-modal {
    width: 95vw;
  }
}
`, "",{"version":3,"sources":["webpack://./src/RSSFeed.css"],"names":[],"mappings":"AAAA,0BAA0B;;AAG1B;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,SAAS;EACT,UAAU;AACZ;;AAEA,+BAA+B;AAC/B;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB,EAAE,gCAAgC;EACpD,mBAAmB;EACnB,uCAAuC;AACzC;;;AAGA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,iBAAiB;EACjB,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,mBAAmB;EACnB,uBAAuB,MAAM,6BAA6B;AAC5D;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB;EACpB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,8BAA8B;EAC9B,+BAA+B;EAC/B,YAAY;EACZ;;;;0CAIwC;EACxC,kBAAkB;EAClB,sBAAsB;EACtB,kCAAkC;EAClC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,YAAY;EACZ,UAAU;EACV,WAAW;EACX;;;;kGAIgG;EAChG,4BAA4B;AAC9B;;AAEA;EACE;IACE,qBAAqB;EACvB;AACF;;AAEA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,uCAAuC;EACvC,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;EACT,UAAU;EACV,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,sCAAsC;EACtC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;EACrB,wBAAwB;EACxB,8BAA8B;EAC9B,kCAAkC;EAClC,oBAAoB;EACpB,kBAAkB;EAClB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,wBAAwB;AACxB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,6BAA6B;EAC7B,YAAY;AACd;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA,8BAA8B;AAC9B;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;;EAEA;IACE,uBAAuB;IACvB,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["/* --- Global Styles --- */\n@import url('https://fonts.googleapis.com/css2?family=Roboto:wght@400;700&family=Merriweather:wght@400;400&display=swap');\n\nbody {\n  font-family: 'Roboto', serif;\n  background-color: #f9f9f9;\n  margin: 0;\n  padding: 0;\n}\n\n/* --- RSS Feed Container --- */\n.rss-feed {\n  background-color: #fff;\n  max-width: 800px;\n  margin-bottom: 40px;\n  margin-top: 5px;\n  margin-left: auto;\n  margin-right: auto;\n  padding: 20px 16px; /* 🔁 previously padding: 20px */\n  border-radius: 10px;\n  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);\n}\n\n\n.rss-feed-title {\n  font-size: 24px;\n  color: #2C3E50;\n  margin: 0 auto 20px;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* --- Category Dropdown --- */\n.category-dropdown {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  padding: 8px 20px;\n  background: #f8f8f8;\n  border-bottom: 1px solid #eee;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: center;     /* ✅ center it horizontally */\n}\n\n.category-dropdown label {\n  font-weight: 500;\n  font-size: 16px;\n  color: #333;\n  margin: 0 !important;\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.category-dropdown select {\n  height: 36px;\n  padding: 4px 12px;\n  border: 1px solid #ccc;\n  border-radius: 6px;\n  font-size: 15px;\n  background-color: white;\n  line-height: 1.2;\n  appearance: none;\n}\n\n.loader {\n  margin: 50px auto;\n  width: 60px;\n  height: 40px;\n  color: #000;\n  border: 2px solid currentColor;\n  border-right-color: transparent;\n  padding: 3px;\n  background: repeating-linear-gradient(\n    90deg,\n    currentColor 0 10px,\n    #0000 0 15px\n  ) 0/0% no-repeat content-box content-box;\n  position: relative;\n  box-sizing: border-box;\n  animation: l5 2s infinite steps(6);\n  display: block;\n}\n\n.loader::before {\n  content: \"\";\n  position: absolute;\n  top: -2px;\n  bottom: -2px;\n  left: 100%;\n  width: 10px;\n  background:\n    linear-gradient(#0000 calc(50% - 7px), currentColor 0 calc(50% - 5px),\n    #0000 0 calc(50% + 5px), currentColor 0 calc(50% + 7px), #0000 0) left/100% 100%,\n    linear-gradient(currentColor calc(50% - 5px), #0000 0 calc(50% + 5px), currentColor 0) left/2px 100%,\n    linear-gradient(#0000 calc(50% - 5px), currentColor 0 calc(50% + 5px), #0000 0) right/2px 100%;\n  background-repeat: no-repeat;\n}\n\n@keyframes l5 {\n  100% {\n    background-size: 120%;\n  }\n}\n\n/* --- RSS Items --- */\n.rss-feed-list {\n  list-style: none;\n  padding: 0;\n  padding: 20px 12px;\n}\n\n.rss-feed-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 20px;\n  padding: 10px;\n  background-color: #f9f9f9;\n  border-radius: 5px;\n}\n\n.rss-feed-item-image {\n  flex: 0 0 120px;\n  height: 120px;\n  margin-right: 20px;\n  cursor: pointer;\n}\n\n.enclosure-image {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 5px;\n}\n\n.rss-feed-item-content {\n  flex: 1;\n}\n\n.rss-feed-item-title {\n  font-size: 18px;\n  color: #333;\n  margin-bottom: 10px;\n  font-family: 'Merriweather', sans-serif;\n  cursor: pointer;\n}\n\n.rss-feed-item-title:hover {\n  color: rgb(82, 109, 244);\n}\n\n.rss-feed-item-description {\n  font-size: 16px;\n  color: #666;\n  margin-bottom: 10px;\n}\n\n.rss-feed-item-date {\n  font-size: 14px;\n  color: #999;\n  margin-bottom: 10px;\n}\n\n/* --- Subscribe Styles --- */\n.subscribe-container {\n  display: flex;\n  justify-content: flex-end;\n  margin: 0;\n  padding: 0;\n  width: auto;\n}\n\n.subscribe-button {\n  background-color: #35495E;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  height: 40px;\n  padding: 0 20px;\n  font-size: 15px;\n  font-weight: 500;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n  transition: background-color 0.3s ease;\n  line-height: 1;\n}\n\n.subscribe-button:hover {\n  background-color: #2c3e50;\n  transform: translateY(-2px);\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);\n}\n\n.subscribe-text {\n  position: relative;\n  top: 1px;\n}\n\n.mobile-button {\n  width: 40px !important;\n  height: 40px !important;\n  padding: 0 !important;\n  display: flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  margin: 0 !important;\n  border-radius: 6px;\n  box-shadow: none !important;\n  vertical-align: middle;\n}\n\n/* --- Blog Header --- */\n.blog-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  background: #fff;\n  padding: 10px 24px;\n  width: 100%;\n  box-sizing: border-box;\n  border-bottom: 1px solid #eee;\n  height: auto;\n}\n\n.nav-home-container,\n.subscribe-container-wrapper {\n  flex-shrink: 0;\n  width: 48px;\n  height: 48px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n  padding: 0;\n}\n\n.subscribe-container-wrapper {\n  height: 40px;\n  width: auto;\n}\n\n/* --- Responsive Styles --- */\n@media (max-width: 600px) {\n  .rss-feed {\n    padding: 20px 12px;\n  }\n\n  .rss-feed-title {\n    font-size: 20px;\n  }\n\n  .rss-feed-item {\n    flex-direction: column;\n    align-items: center;\n  }\n\n  .rss-feed-item-image {\n    width: 100%;\n    height: auto;\n    margin-bottom: 10px;\n  }\n\n  .category-dropdown {\n    justify-content: center;\n    gap: 10px;\n    padding: 10px 15px;\n  }\n\n  .category-dropdown label {\n    margin: 0 !important;\n  }\n\n  .subscribe-modal {\n    width: 95vw;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
